"use client";

import { Sparkles } from "lucide-react";

type Item = {
  name: string;
  url: string;
  image?: string;
  price?: string;
};

export type ItemCardsProps = {
  items: Item[];
  onItemClick: (item: { name: string; url: string; image?: string }) => void;
  variant?: "voice" | "chat";
};

export default function ItemCards({
  items,
  onItemClick,
  variant = "voice",
}: ItemCardsProps) {
  if (items.length === 0) return null;

  if (variant === "voice") {
    return (
      <div className="space-y-3">
        <div className="flex items-center gap-1.5 px-1">
          <Sparkles className="w-4 h-4 text-[#e99bad]" />
          <span className="text-sm font-medium text-slate-700">
            おすすめのアイテム
          </span>
        </div>
        <div className="flex gap-3 overflow-x-auto pb-2 [scrollbar-width:none] [-ms-overflow-style:none] [&::-webkit-scrollbar]:hidden">
          {items.map((item, i) => (
            <div
              key={i}
              className="flex-shrink-0 w-36 rounded-xl bg-white border border-slate-100 shadow-sm hover:shadow-md transition-shadow cursor-pointer overflow-hidden"
              onClick={() => onItemClick(item)}
            >
              {item.image ? (
                <img
                  src={item.image}
                  alt={item.name}
                  className="h-24 w-full object-cover"
                />
              ) : (
                <div className="h-24 w-full bg-slate-100" />
              )}
              <div className="p-2.5">
                <p className="text-xs font-medium text-slate-700 line-clamp-2 leading-snug">
                  {item.name}
                </p>
                {item.price && (
                  <p className="text-xs text-slate-400 mt-1">{item.price}</p>
                )}
              </div>
            </div>
          ))}
        </div>
      </div>
    );
  }

  return (
    <div className="flex gap-3 overflow-x-auto pb-2 [scrollbar-width:none] [-ms-overflow-style:none] [&::-webkit-scrollbar]:hidden">
      {items.map((item, i) => (
        <div
          key={i}
          className="group flex-shrink-0 w-36 rounded-xl bg-white border border-[#e99bad]/10 hover:border-[#e99bad]/40 transition-colors cursor-pointer overflow-hidden"
          onClick={() => onItemClick(item)}
        >
          {item.image ? (
            <img
              src={item.image}
              alt={item.name}
              className="h-24 w-full object-cover"
            />
          ) : (
            <div className="h-24 w-full bg-slate-100" />
          )}
          <div className="p-2.5">
            <p className="text-xs font-medium text-slate-700 line-clamp-2 leading-snug">
              {item.name}
            </p>
            {item.price && (
              <p className="text-xs text-slate-400 mt-1">{item.price}</p>
            )}
          </div>
        </div>
      ))}
    </div>
  );
}
